/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useState } from 'react';

import { MdError } from 'react-icons/md';
import { getGrid } from '~/pages/LinhasDeCuidadoGrid/collumns';

import { Container } from './styles';

const ExceptionsForm = ({ lc, exceptions = [] }) => {
  const [dataGrid, setDataGrid] = useState([]);

  useEffect(() => {
    if (exceptions.length > 0) {
      const grid = getGrid(lc);

      setDataGrid(grid());
    }
  }, [exceptions, lc]);

  const getDescription = useCallback(
    key => {
      const result = dataGrid.filter(v => v.key?.trim() === key);

      if (result.length > 0) {
        return `${result[0]?.title}: `;
      }

      return '';
    },

    [dataGrid]
  );

  return (
    <Container>
      <p>Relatório de inconsistências:</p>
      {exceptions.length > 0 &&
        exceptions.map(({ parameter, exception, value }) => {
          return (
            <div key={`${parameter}-${exception}`}>
              <div className="iconException">
                <MdError size={20} color="#cc0000" />
              </div>
              <div className="exceptionsBoxContent">
                <strong>{parameter && getDescription(parameter)} </strong>
                <span>
                  {/* {exception}  */}
                  {value && ` ${value}`}
                </span>
              </div>
            </div>
          );
        })}
    </Container>
  );
};

export default ExceptionsForm;
